/**
 * This file overrides antd's default theme variables in:
 * https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less
 */

module.exports = {
  'primary-color': '#096dd9',

  // Most modern desktop browsers have a default font size of 16px, which is quite good
  // for English. Starting from antd v3.0, the font-size-base is enlarged to 14px from
  // 12px. This is good for Chinese display. If our main language is English, we can consider
  // changing it to 16px.
  'font-size-base': '14px',

  // Prefer Open Sans first. We also need to add the font link in index.html file.
  'font-family': `'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',
  'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji',
  'Segoe UI Emoji', 'Segoe UI Symbol'`,

  // The default font colors used by antd are as follows. We change them to match with
  // the ones we use in the default.jsx theme.
  // @text-color             : fade(#000, 65%); // Default.
  // @text-color-secondary   : fade(#000, 43%);
  // @text-color-dark        : fade(#fff, 91%);
  // @text-color-secondary-dark: fade(#fff, 67%);

  'text-color': 'rgba(0, 0, 0, 0.87)', // textPrimaryDark
  'text-color-secondary': 'rgba(0, 0, 0, 0.54)', // textSecondaryDark
  // 'text-color-secondary': 'rgba(0, 0, 0, 0.60)', // textSecondaryDark
  'text-color-dark': 'rgba(255, 255, 255, 1)', // textPrimaryLight
  'text-color-secondary-dark': 'rgba(255, 255, 255, 0.7)', // textSecondaryLight

  'input-placeholder-color': 'rgba(0, 0, 0, 0.34)',
  'disabled-color': 'rgba(0, 0, 0, 0.7)',

  // The original margin bottom for form items is 24px. We change it to 16px to
  // keep it the same as the metronic template.
  'form-item-margin-bottom': '16px',
};
